type AnalyticsEvent = {
  event?: string;
  properties?: Record<string, unknown>;
};

function exceptionMessages(properties: Record<string, unknown> | undefined) {
  if (!properties) return [];

  const messages: string[] = [];
  const directMessage = properties.$exception_message;
  if (typeof directMessage === "string") messages.push(directMessage);

  const exceptionList = properties.$exception_list;
  if (Array.isArray(exceptionList)) {
    for (const exception of exceptionList) {
      if (!exception || typeof exception !== "object") continue;
      const value = (exception as { value?: unknown }).value;
      if (typeof value === "string") messages.push(value);
    }
  }

  return messages;
}

export function shouldDiscardBrowserAnalyticsEvent(event: AnalyticsEvent) {
  if (event.event !== "$exception") return false;
  return exceptionMessages(event.properties).some(
    (message) => message.trim() === "NEXT_REDIRECT"
  );
}
